import { IApplicationState } from '../../types/redux';

export function getFullAddress(state: IApplicationState) {
  const {
    newbuilding: { fullAddress },
  } = state;

  return fullAddress;
}
